<ng-template #t>
  <ng-content select="mp-entity-list-head" />
  <ng-content select="mp-entity-item" />
  <ng-content select="mp-entity-item-slots" />
</ng-template>
<ng-container [ngTemplateOutlet]="t" />
